export default "__VITE_ASSET__nYp4eBOl__"